import { feedblockTypes } from '@constants/index';

const isEducatorFeed = (feedBlockEntityType) =>
  feedBlockEntityType === 'Educator';

const isClassFeed = (feedBlockEntityType) => feedBlockEntityType === 'Course';

const isBatchFeed = (feedBlockEntityType) => feedBlockEntityType === 'Batch';

const isTopicFeed = (feedBlockEntityType) =>
  ['Topology', 'topology', 'topics', 'topic', 'topic_groups', 'group'].includes(
    feedBlockEntityType
  );

const isTestSeriesFeed = (feedBlockEntityType) =>
  ['TestSeries', 'Test_Series'].includes(feedBlockEntityType);

const isGenericBanner = (feedBlockType) =>
  feedBlockType === feedblockTypes.GENERIC_BANNER;

const isPreActivationBlock = (feedBlockType) =>
  [
    feedblockTypes.EXT_SUBSCRIPTION_PREACTIVATION,
    feedblockTypes.EXT_SUBSCRIPTION_POSTACTIVATION
  ].includes(feedBlockType);

const isCourseFeedBlock = (feedBlockType) =>
  [
    'Course',
    'TestSeries',
    'Test_Series',
    'legends_on_unacademy',
    'banner'
  ].includes(feedBlockType);

const isEducatorBlock = (feedBlockType) => ['Educator'].includes(feedBlockType);

const isBatchBlock = (feedBlockType) => ['Batch'].includes(feedBlockType);

const isBannerBlock = (feedBlockType) =>
  ['carousel_feed'].includes(feedBlockType);

export {
  isClassFeed,
  isEducatorFeed,
  isBatchFeed,
  isTopicFeed,
  isTestSeriesFeed,
  isGenericBanner,
  isPreActivationBlock,
  isCourseFeedBlock,
  isEducatorBlock,
  isBatchBlock,
  isBannerBlock
};
